import type { FaireProductEntity } from "../../entity_types/product";

export const p_s47vzqyazd: FaireProductEntity = {
  token: "p_s47vzqyazd",
  type: "product",
  name: "Arizona Edition - Ray the Canned Sunshine - Sun Plush",
  brandToken: "b_d2r2bs3j23",
  brandName: "Canned Gifts",
  imageUrl:
    "https://cdn.faire.com/fastly/7f3dacf1ddc834e24211612c4538bc53d645c28eb3f5ca2330682e2de00ad157.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7af924d0e89325270cf834162e3d799d4751b3a55ad2726536e6d54b92d0b02b.png",
    "https://cdn.faire.com/fastly/887a79f7412e5c6ce1be381f26c361ecdd76161640f6597f6b8e96e9c1370ba1.png",
    "https://cdn.faire.com/fastly/b8d2a30a64b60ae2836ebe6ef27caa19af3feb932563359410e2b6836d28e928.png",
    "https://cdn.faire.com/fastly/1e46ca697399005d4dfd6a78a808526ade14df54dab2956f8b5c687fe16e5b8c.png",
    "https://cdn.faire.com/fastly/7544c2956fc4846658496667c079ca422f06e0dc626af93df7a41349f603a133.png",
  ],
  priceDollars: 14.55,
  description:
    "Arizona State Special Edition Can!\n\n•\tRay the Canned Sunshine. 1 plush sunshine sealed in a soup can. Your choice of lid style: pop top, foil, or standard (open with a can opener).\n•\tEco-Friendly\n•\tPlush measures approx. 5 inches.\n•\tFunny sunshine jokes and interesting facts about Arizona sun on the can.\n•\tDesigned and canned in the USA. Label made in USA. Sunshine made in Indonesia.\n\nArizona state Sedona Phoenix Tucson Mesa Chandler Glendale Scottsdale Gilbert Tempe Peoria Surprise Flagstaff Yuma Prescott Queen Creek, Good year, Buckeye, Maricopa\n\n*Testers are an open can with the plush prepared for display",
  tags: [],
  msrpDollars: 29.1,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:54.504Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
